import { RouterModule, Routes } from '@angular/router';

let routes: Routes = [
  {
    path: '',
    loadChildren: () => import('../pages/imobiliare-nivelul-2/imobiliare-nivelul-2.module').then((m) => m.ImobiliareNivelul2Module),
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '/',
    pathMatch: 'full',
  },
];

export const AppRouting = RouterModule.forRoot(routes, {
  initialNavigation: 'enabledBlocking'
});
